import { useQuery } from "@tanstack/react-query";
import { OPERATION_KEYS } from "./keys";
import { FilterParams, PaginationParams } from "../type";
import { operationServices } from "./operation.services";
import { GetStaffParams } from "./operation.types";
import { GetSuppliesParams } from "../supply";

export const useGetAllStaff = (params?: GetStaffParams) => {
  return useQuery({
    queryKey: OPERATION_KEYS.GET_ALL_STAFF(params),
    queryFn: () => operationServices.getAllStaff(params),
  });
};

export const useGetStaffById = (id?: string, enabled = true) => {
  return useQuery({
    queryKey: OPERATION_KEYS.GET_STAFF_BY_ID(id!),
    queryFn: () => operationServices.getStaffById(id!),
    enabled: !!id && enabled,
  });
};

export const useGetAllVessel = (params?: FilterParams & PaginationParams) => {
  return useQuery({
    queryKey: OPERATION_KEYS.GET_ALL_VESSEL(params),
    queryFn: () => operationServices.getAllVessel(params),
  });
};

export const useGetAllSupplies = (params?: GetSuppliesParams) => {
  return useQuery({
    queryKey: OPERATION_KEYS.GET_ALL_SUPPLY(params),
    queryFn: () => operationServices.getAllSupplies(params),
  });
};

export const useGetStaffActivityToday = (id?: string) => {
  return useQuery({
    queryKey: OPERATION_KEYS.GET_STAFF_ACTIVITY_TODAY(id!),
    queryFn: () => operationServices.getStaffActivityToday(id!),
    enabled: !!id,
  });
};

export const useGetStaffWeeklyActivities = (
  id?: string,
  startDate?: string,
  params?: { enabled: boolean }
) => {
  return useQuery({
    queryKey: OPERATION_KEYS.GET_STAFF_WEEKLY_ACTIVITIES(id!, startDate),
    queryFn: () => operationServices.getStaffWeeklyActivities(id!, startDate),
    enabled: !!id && params?.enabled,
  });
};

export const useGetStaffCurrentStatusActivity = (id?: string) => {
  return useQuery({
    queryKey: OPERATION_KEYS.GET_STAFF_CURRENT_STATUS_ACTIVITY(id!),
    queryFn: () => operationServices.getStaffCurrentStatusActivity(id!),
    enabled: !!id,
  });
};

export const useGetStaffAvailabilityDetails = (
  id: string,
  startDate?: string,
  endDate?: string,
  enabled: boolean = true
) => {
  return useQuery({
    queryKey: ["staff-availability-details", id, startDate, endDate],
    queryFn: () => operationServices.getStaffAvailabilityDetails(id, startDate, endDate),
    enabled: enabled && !!id,
  });
};
